export default __webpack_public_path__ + "static/artistBox-rara-rocora-db4eb40b89aa64612e9372df8f88db90.png";